import React from 'react';
import PropTypes from 'prop-types';

class ButtonComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    return (
      <button
        type="button"
        className={`${this.props.className} type--jura`}
        onClick={this.onClick}
        disabled={this.props.disabled}
        data-cy="button-continue"
        data-test-id={`${this.props.dataTestId}`}
      >
        {this.props.hasIcon ? (
          <span className={this.props.iconName}>
            {/* <span className="icon icon-chevron-down"></span>*/}
          </span>
        ) : null}
        {this.props.btnName}
      </button>
    );
  }
}

ButtonComponent.propTypes = {
  btnName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  iconClass: PropTypes.string,
  iconName: PropTypes.string,
  style: PropTypes.string,
  hasIcon: PropTypes.bool,
  iconPosition: PropTypes.string,
  children: PropTypes.node,
};
// Specifies the default values for props:
ButtonComponent.defaultProps = {
  className: 'btn',
  btnName: '',
  hasIcon: false,
  disabled: false,
  dataTestId: 'button-continue',
};
export default ButtonComponent;
